module.exports = __webpack_public_path__ + "static/media/open-sans-v17-latin-ext_latin-700italic.d7e0c8f4.woff";